import { GetApplicationsQueryResult } from '@sdir/httpclient/lib/clients/aps/application';
// eslint-disable-next-line max-len
import { CustomStatusLabelStatus } from '@sdir/blueprint.aps/lib/components/Atoms/CustomStatusLabel';
import { ApplicationStatus, SimplifiedApplicationStatus } from '../types/enums';

export const getSimplifiedApplicationStatus = (application: GetApplicationsQueryResult) => {
  switch (application.applicationStatus) {
    case ApplicationStatus.Start:
    case ApplicationStatus.Draft:
      return SimplifiedApplicationStatus.Setup;
    case ApplicationStatus.Payment:
      return SimplifiedApplicationStatus.AwaitingPayment;
    case ApplicationStatus.RequestMoreInformation:
      return SimplifiedApplicationStatus.MoreInfoRequested;
    case ApplicationStatus.CheckQualification:
    case ApplicationStatus.ManualProcessing:
    case ApplicationStatus.QASample:
      return SimplifiedApplicationStatus.Processing;
    case ApplicationStatus.Approved:
    case ApplicationStatus.CreateCertificate:
      return SimplifiedApplicationStatus.Approved;
    case ApplicationStatus.Archive:
    case ApplicationStatus.Final:
    case ApplicationStatus.Done:
      return SimplifiedApplicationStatus.Processed;
    case ApplicationStatus.Rejected:
    case ApplicationStatus.RequestMoreInformationTimedOut:
      return SimplifiedApplicationStatus.Rejected;
    default:
      return SimplifiedApplicationStatus.Setup;
  }
};

export const mapToCustomStatusLabel = (application: GetApplicationsQueryResult) => {
  switch (application.applicationStatus) {
    case ApplicationStatus.Start:
    case ApplicationStatus.Draft:
    case ApplicationStatus.Payment:
      return CustomStatusLabelStatus.New;
    case ApplicationStatus.RequestMoreInformation:
      return CustomStatusLabelStatus.Waiting;
    case ApplicationStatus.CheckQualification:
    case ApplicationStatus.ManualProcessing:
    case ApplicationStatus.QASample:
      return CustomStatusLabelStatus.Response;
    case ApplicationStatus.Approved:
    case ApplicationStatus.CreateCertificate:
    case ApplicationStatus.Archive:
    case ApplicationStatus.Final:
    case ApplicationStatus.Done:
      return CustomStatusLabelStatus.Done;
    case ApplicationStatus.Rejected:
    case ApplicationStatus.RequestMoreInformationTimedOut:
      return CustomStatusLabelStatus.Rejected;
    default:
      return CustomStatusLabelStatus.New;
  }
};

export const isOpenApplication = (applicationStatus: string) => {
  switch (applicationStatus) {
    case ApplicationStatus.Approved:
    case ApplicationStatus.Final:
    case ApplicationStatus.Done:
    case ApplicationStatus.Rejected:
      return false;
    default:
      return true;
  }
};

export const isPaymentEnabled = (applicationStatus: string) => {
  switch (applicationStatus) {
    case ApplicationStatus.Payment:
      return true;
    default:
      return false;
  }
};
